import { useLayoutEffect, useState, useEffect } from 'react';

// Scrive data-theme su <html> (impostato dallo script inline in index.html, unica
// fonte usata da :root) E su <body> (alcuni SCSS usano `body[data-theme]`).
// Tenerli in sync evita attributi desincronizzati: lasciare <html> stale impediva
// il ritorno a light, perché non esiste un blocco [data-theme='light'] e il body
// ereditava le variabili dark rimaste su <html>.
const setThemeAttribute = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
  document.body.setAttribute('data-theme', theme);
};

const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Applica il tema rispettando la scelta manuale dell'utente
  // poi fallback alla preferenza di sistema
  const applyTheme = () => {
    const manualPreference = localStorage.getItem('isDark');
    let prefersDark;
    if (manualPreference !== null) {
      prefersDark = manualPreference === 'true';
    } else {
      prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    const theme = prefersDark ? 'dark' : 'light';
    setThemeAttribute(theme);
    setIsDarkMode(prefersDark);
  };

  // set theme al mount
  useLayoutEffect(() => {
    applyTheme();
  }, []);

  // Segui le preferenze di sistema in tempo reale (es. orario automatico light/dark del SO)
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleSystemThemeChange = (e) => {
      // Solo se l'utente non ha una preferenza manuale
      const manualPreference = localStorage.getItem('isDark');
      if (manualPreference !== null) return;

      const newDarkMode = e.matches;
      setIsDarkMode(newDarkMode);
      setThemeAttribute(newDarkMode ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleSystemThemeChange);

    return () => {
      mediaQuery.removeEventListener('change', handleSystemThemeChange);
    };
  }, []);

  // change mode
  const changeMode = () => {
    const newState = !isDarkMode;
    setIsDarkMode(newState);
    localStorage.setItem('isDark', newState);
    setThemeAttribute(newState ? 'dark' : 'light');
  };

  return { isDarkMode, changeMode };
};

export default useDarkMode;
